import "../../styles/footer.css";
import {
  FaFacebookF,
  FaInstagram,
} from "react-icons/fa";
import { MdEmail, MdPhone, MdLocationOn } from "react-icons/md";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo_round.png";
import text_logo from "../../assets/images/logo.png";
import white_text_logo from "../../assets/images/white_text_logo.png";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* TOP ROW */}
        <div className="footer-top">
          {/* LOGO */}
          <div className="footer-brand">
            <div className="foot-logo">
              <img src={logo} alt="3D Print Models" />
            </div>
            <span>
              <img
                src={white_text_logo}
                alt="3D Print Models"
                style={{ height: "36px" }}
              />
            </span>
          </div>

          {/* NAV */}
          <ul className="footer-nav">
            {/* <li>Services</li> */}
            <li>About</li>
            <li>Gallery</li>
            <li>
              <Link to="/terms-and-conditions">Terms and Conditions</Link>
            </li>
            <li>
              <Link to="/privacy-policy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/return-policy">Refund and Return Policy</Link>
            </li>
            <li>
              <Link to="/contact#contact">Contact Us</Link>
            </li>
          </ul>

          {/* SOCIAL */}
          <div className="footer-social">
            <a
              href="https://www.facebook.com/profile.php?id=61586690636144"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF />
            </a>
            {/* <a href="https://www.instagram.com/the3dcreator.co/">
              <FaTwitter />
            </a> */}
            <a
              href="https://www.instagram.com/the3dcreator.co/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>
            {/* <a href="https://www.instagram.com/the3dcreator.co/">
              <FaLinkedinIn />
            </a> */}
          </div>
        </div>

        <div className="footer-divider"></div>

        {/* BOTTOM ROW */}
        <div className="footer-bottom">
          <div className="footer-info">
            <MdEmail />
            <span>support@the3dcreator.com</span>
          </div>

          <div className="footer-info">
            <MdPhone />
            <span>+91 8223839384</span>
          </div>

          <div className="footer-info">
            <MdLocationOn />
            <span>
              Inner Bypass, Near India oil petrol pump, Bhatapara,
              Chhattisgarh-493118
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
